var _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendarActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.03885 6.42885H20.1429M4.14285 1.85742H17.8571C18.4633 1.85742 19.0447 2.09824 19.4734 2.52689C19.902 2.95555 20.1429 3.53693 20.1429 4.14314V17.846C20.1429 18.4522 19.902 19.0336 19.4734 19.4622C19.0447 19.8909 18.4633 20.1317 17.8571 20.1317H4.14285C3.53664 20.1317 2.95526 19.8909 2.52661 19.4622C2.09796 19.0336 1.85714 18.4522 1.85714 17.846V4.14314C1.85714 3.53693 2.09796 2.95555 2.52661 2.52689C2.95526 2.09824 3.53664 1.85742 4.14285 1.85742V1.85742Z",
    stroke: "url(#paint0_linear_708_5563)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.78971 14.0337V12.8006H7.79542C8.55885 12.8006 9.07771 12.3492 9.07771 11.6897C9.07771 11.0874 8.60342 10.6303 7.81714 10.6303C7.00228 10.6303 6.50056 11.0486 6.44456 11.7686H4.88571C4.94399 10.284 6.08685 9.28516 7.90057 9.28516C9.68685 9.28516 10.68 10.2726 10.6743 11.4509C10.6686 12.4269 10.0549 13.0692 9.18971 13.2806V13.3869C10.3109 13.548 10.992 14.2623 10.992 15.34C10.992 16.7514 9.66399 17.7514 7.84456 17.7514C6.02514 17.7514 4.78628 16.756 4.71428 15.2326H6.32685C6.37714 15.9137 6.95771 16.3492 7.82285 16.3492C8.67656 16.3492 9.27428 15.8852 9.27428 15.188C9.27428 14.4737 8.71542 14.0337 7.81142 14.0337H6.78971ZM14.4469 17.5446V11.132H14.3474L12.3714 12.4943V10.9263L14.4526 9.49201H16.1326V17.5446H14.4469Z",
    fill: "#E87A46"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_708_5563",
    x1: 20.1429,
    y1: 10.9946,
    x2: 1.85714,
    y2: 10.9946,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9B225F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E40E41"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarActive);
export default __webpack_public_path__ + "static/media/CalendarActive.37bbd6b7c491feb74f2ae8b5a5a51c8d.svg";
export { ForwardRef as ReactComponent };